import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-5816b689"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "common-page account-add-page" }
const _hoisted_2 = {
  class: "w100 auto",
  style: {"height":"calc(100% - 30px)"}
}
const _hoisted_3 = { class: "page-containter" }
const _hoisted_4 = { class: "page-main" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("a", {
  style: {"color":"#1E8CCE"},
  href: "#/system_setting/account-manage"
}, "帐号管理", -1))
const _hoisted_6 = { class: "page-view" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_a_breadcrumb_item = _resolveComponent("a-breadcrumb-item")!
  const _component_a_breadcrumb = _resolveComponent("a-breadcrumb")!
  const _component_oem_learn_more = _resolveComponent("oem-learn-more")!
  const _component_nav_list = _resolveComponent("nav-list")!
  const _component_router_view = _resolveComponent("router-view")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createVNode(_component_a_breadcrumb, { separator: ">" }, {
            default: _withCtx(() => [
              _createVNode(_component_a_breadcrumb_item, null, {
                default: _withCtx(() => [
                  _hoisted_5
                ]),
                _: 1
              }),
              _createVNode(_component_a_breadcrumb_item, null, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.engineer.user.name || '添加客服'), 1)
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          _createVNode(_component_oem_learn_more, {
            style: {"margin-top":"15px","margin-left":"10px"},
            type: "system_setting_engineer_edit",
            description: "设置组织架构下各部门的父级部门及协同部门，协同部门可共同处理会话、工单。",
            "learn-more-url": _ctx.eweiHelpcenterApiUrl + 'new/#/article/detail/379'
          }, null, 8, ["learn-more-url"]),
          _createVNode(_component_nav_list, {
            "menu-list": _ctx.menuList,
            style: {"margin":"20px 0 15px 0"}
          }, null, 8, ["menu-list"])
        ]),
        _createElementVNode("div", _hoisted_6, [
          _createVNode(_component_router_view, {
            query: { 'id': _ctx.engineer.id, userId: _ctx.engineer.user?.id }
          }, null, 8, ["query"])
        ])
      ])
    ])
  ]))
}